import { defineStore } from "pinia";
import type { TripMonitorItem, TripMonitorRoute, TripMonitorTruck } from "@/api/trips/dto/trip-monitor";
import type { TripService } from "@/services/socket/trip.service";
import type { TripOverview, TripOverviewTab } from "@/api/trips/dto/trip.dto";

interface TripStore {
  tripMonitorService: TripService | null;
  tripMonitorItem: TripMonitorItem | null;
  tripMonitorItemRoute: TripMonitorRoute | null;
  tripTruck: TripMonitorTruck | null;
  tripOverview: TripOverview | null;
  tripOverviewTab: TripOverviewTab;
  tripId: number | null;
}

export const useTripStore = defineStore("tripStore", {
  state: (): TripStore => ({
    tripMonitorService: null,
    tripMonitorItem: null,
    tripMonitorItemRoute: null,
    tripTruck: null,
    tripOverview: null,
    tripOverviewTab: "trip-view",
    tripId: null,
  }),
  actions: {
    setTripMonitorService(service: TripService | null) {
      this.tripMonitorService = service;
    },
    setTripMonitorItem(data: TripMonitorItem | null) {
      this.tripMonitorItem = data;
    },
    setTripMonitorItemRoute(data: TripMonitorRoute | null) {
      this.tripMonitorItemRoute = data;
    },
    setTripTruck(data: TripMonitorTruck | null) {
      this.tripTruck = data;
    },
    updateTripOverview(data: TripOverview | null) {
      if (this.tripOverview && data) {
        if (this.tripOverview.id === data?.id) {
          this.tripOverview = data;
        }
      } else {
        this.tripOverview = data;
      }
    },
    updateTripOverviewTab(value: TripOverviewTab) {
      this.tripOverviewTab = value;
    },
    setTripId(value: number | null) {
      this.tripId = value;
    },
  },
});
